export interface Client {
  id: string;
  clientId: string;
  name: string;
}

export type Organization = {
  id: string;
  name: string;
  attributes?: Record<string, any>;
}
export type Owner = Organization;

export class Permission {
  id?: string;
  name: string;
  roles: Array<string | ClientRole>;

  constructor() {
    this.name = "";
    this.roles = [];
  }
}

export class ClientRole {
  name: string;
  clientId: string;

  constructor() {
    this.name = "";
    this.clientId = "";
  }
}

export interface PermissionEditDTO {
  id?: string;
  name: string;
  roles: PermissionRoles;
}

export interface PermissionRoles {
  realmRoles: string[];
  clientRoles: Record<string, string[]>;
}

export interface Group {
  access: any;
  attributes: any;
  clientRoles: Record<string, string[]>;
  id: string;
  name: string;
  parentId: string;
  path: string;
  realmRoles: any[];
  subGroupCount: number;
  subGroups: any[];
}